import React from 'react';
import { formatGold } from '../../utils/goldNotation';
import { formatDate } from '../../utils/transparency';

const HistoryList = ({ history, selected, onSelect }) => {
  if (history.length === 0) {
    return <p className="text-gray-400 text-sm">Nenhum pagamento BC registrado ainda.</p>;
  }

  return (
    <div className="space-y-2">
      {history.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onSelect(item.id)}
          className={`w-full text-left flex flex-col sm:flex-row sm:items-center justify-between gap-2 p-4 rounded-xl border transition-all ${
            selected === item.id
              ? 'bg-cyan-500/10 border-cyan-500/50'
              : 'bg-white/5 border-white/10 hover:bg-white/10'
          }`}
        >
          <div>
            <p className="text-white font-semibold">{item.name}</p>
            <p className="text-gray-400 text-xs">{formatDate(item.eventDate)}</p>
          </div>
          <div className="flex items-center gap-6">
            <span className="text-gray-300 text-sm">
              {item.resolvedCount}/{item.beneficiaryCount} pagos/doados
            </span>
            <span className="text-white font-bold" title={Number(item.prizeAmount).toLocaleString('pt-BR')}>
              {formatGold(item.prizeAmount)}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
};

export default HistoryList;
